/**
 * @file cookie-util.js
 * @brief Utility functions for finding cookies.
 *
 * Provides utility functions for working with cookies.
 */

// *******************************************************************************************************
// Exported functions START
// *******************************************************************************************************

/**
 * Returns true or false depending on the existence of a cookie with a desired value.
 * @param {string} cookieName - The name of the cookie to look for.
 * @param {string} cookieValue - The desired value the cookie should have.
 * @returns {boolean} cookieFound
 */
export function findCookie(cookieName, cookieValue) {
    let cookieFound = false;
    const cookies = document.cookie.split("; ");

    if(!cookies) return cookieFound;

    cookies.forEach((cookie) => {
        const [key, value] = cookie.split("=");

        if(key === cookieName && value === cookieValue) {
            cookieFound = true;
        }
    });

    return cookieFound;
}

// -------------------------------------------------------------------------------------------------------
// Exported functions END
// -------------------------------------------------------------------------------------------------------